export default __webpack_public_path__ + "static/media/arrow-drop-up-icon.bc71bfc3.svg";